import { render, staticRenderFns } from "./PlantSeed.vue?vue&type=template&id=a0577f2a&"
import script from "./PlantSeed.vue?vue&type=script&lang=js&"
export * from "./PlantSeed.vue?vue&type=script&lang=js&"
import style0 from "./PlantSeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports